import React, { useState } from 'react'
import BaseHome from '../../Home/BaseHome'
import TabPanelSolid, { TabPanel } from '../../Common/TabPanelSolid'
import ManageDetails from './ManageDetails'
import ManageLeaderboard from './ManageLeaderboard'
import ManageRules from './ManageRules'
import { useNavigate, useParams } from 'react-router'
import { t } from 'i18next'

const ManageScrim = () => {
  const tabs = [t("private_contest.details"), t("private_contest.leaderboard"), t("private_contest.rules")]
  const [value, setValue] = useState(0)
  const { id } = useParams();
  const navigate = useNavigate();

  const getTabs = (val, index, activeTab) => {
    return (
      <TabPanel className="rewards-body" value={val} index={index}>
        <div className='scroll-none '>
          {
            index == 0 ? <ManageDetails scrimId={id} /> :
              index == 1 ? <ManageLeaderboard scrimId={id} />
                : <ManageRules scrimId={id} />

          }

        </div>
      </TabPanel>
    )
  }
  return (
    <BaseHome title={t("private_contest.private_contest")} onBackClick={()=>{
      navigate(`/my-contest/list/${localStorage.getItem("activeGameId")}`);
    }}>
      <TabPanelSolid tabs={tabs} value={value} setValue={setValue} getTabs={getTabs} />
    </BaseHome>
  )
}

export default ManageScrim